import  {useState,useRef, useEffect, useCallback} from "react";
import { useSelector , useDispatch } from "react-redux";
// import InfiniteScroll from "react-infinite-scroller";

import { useUser , useCommissions} from '../../state/reactquery';
 

import { imagesorigine } from '../../utils/utils_courtier';
import { formatdatetime } from "../../utils/utils_dates";
import { listestatus } from "../../utils/listeprogression";
import { gotoficheclientgestion } from "../../utils/actions_lead";



import PopupReassigner from "../../Components/Popup/PopupReassigner";
import PopupChangeStatut from "../../Components/Popup/PopupChangeStatut";
import PopupSupprimer from "../../Components/Popup/PopupSupprimer";
import Mimi from "../../Components/Popup/Mimi";

import './EcranGestionListe.scss' ;



function finddoublons(leads){
    const emailSet =  new Set();const emaildoublons =[] ;
    for(let lead of leads){
        emailSet.has(lead.email) && emaildoublons.push(lead.email) ;
        emailSet.add(lead.email)
    }
    const doublons =  leads.filter(l=>emaildoublons.includes(l.email))
    return {nb:doublons.length , doublons }
}


function prixtotaldate(listeleads,commissions){
    if(!listeleads || listeleads.length===0 || !commissions || commissions.length===0){return 0}
    let total = 0;
    for(let lead of listeleads) {
            const originecampagne = lead.origine+lead.campagne?.split('/')[0]?.trim() || '' ;
            const date_origine = lead.date_origine ;
            const prix = commissions.filter(c=>c.origine+c.campagne===originecampagne && new Date(date_origine) >= new Date(c.debut) && new Date(date_origine) < new Date(c.fin) )?.[0]?.prix || 0;
            total+=parseFloat(prix) ;
        }
    return total

}


const convertdate = (date)=>{ return (new Date(date)).toLocaleString("fr-FR",{timeZone:"Europe/Paris"})}

const classNames = require('classnames');
function EcranGestionListe(){
    const dispatch = useDispatch() ;
    const {data : commissions}= useCommissions() ;
    const {data: user} = useUser(localStorage.getItem('token'))  ;
    const divScrollRef = useRef(null);

    const {affFxNum=[],affLeads =[],choiceliste , categories}= useSelector(state=>state.gestion);

    const doublons = finddoublons(affLeads)?.doublons?.sort((b,a)=>{return  b.email > a.email ? 1:b.email  < a.email?-1 :0   }) ; 
    

    const [checkall, setCheckall]  = useState(false) ;  
    const [listidchange,setListidchange] = useState([]);
    const [showpopupreassigner, setShowpopupreassigner] = useState(false);
    const [showpopupsupprimer, setShowpopupsupprimer] = useState(false);
    const [showpopupchangestatut, setShowpopupchangestatut] = useState(false);
    const [showpopupmimi, setShowpopupmimi] = useState(false);
    const [datasliste, setDatasliste] = useState([]) ;
    const [datasshown, setDatasshown] = useState([]) ;
    const [displayprixleads,setDisplayprixleads] = useState(false) ;
    const [prixleads,setPrixleads] = useState(0) ;
    
    const myliste = [...categories?.[choiceliste]]?.sort((a,b)=>new Date(new Date(b.date_origine) - new Date(a.date_origine)))??[] ; 


    useEffect(() => {
        let alldatas = [...categories?.[choiceliste]]?.sort(
            (a, b) => new Date(b.date_origine) - new Date(a.date_origine)
        );

        const first20 = alldatas.splice(0, 20);

        setDatasliste(alldatas);
        setDatasshown(first20);

        if (divScrollRef.current) {
            divScrollRef.current.scrollTo(0, 0);
        }
    }, [categories, choiceliste]);


    useEffect(()=>{
            const toto =  prixtotaldate(affLeads,commissions) ;
            setPrixleads(toto) ;
            setDisplayprixleads(true)
    },[affLeads,commissions])

       const handleScroll = useCallback(() => {
        const div = divScrollRef.current;
        if (!div) return;

        if (datasliste.length === 0) return;

        const bottom = div.scrollHeight - div.scrollTop - div.clientHeight;

        if (bottom < 150) {
            const copy = [...datasliste];
            const slice = copy.splice(0, 20);

            setDatasliste(copy);
            setDatasshown(prev => [...prev, ...slice]);
        }

    }, [datasliste]);


    useEffect(() => {
        const div = divScrollRef.current;
        if (!div) return;

        div.addEventListener("scroll", handleScroll);
        return () => div.removeEventListener("scroll", handleScroll);
    }, [handleScroll]);



    const clickall = () =>{setCheckall(!checkall);const newlistid = checkall ?[]:myliste.map(x=>x.id);setListidchange(newlistid);}

    const clickcheckbox = (e) => {
        setListidchange((prevSelected) => {
                if (!prevSelected.includes(e.target.name)) {return [...prevSelected, e.target.name]; }
                else { return prevSelected.filter((current) => current !== e.target.name);}
        });
    };

    const listetocsv = async(leads)=>{

        if(choiceliste==='choicefauxnumerosdoublons'){
            affFxNum?.length>0 && await exportcsv(affFxNum,'fxnumeros') ; 
            doublons?.length>0 && await exportcsv(doublons,'doublons') ; 
        }else{exportcsv(leads,choiceliste)}

    }

    
    const leadline = (lead)=>[convertdate(lead.date_origine),lead.nom+' '+lead.prenom,lead.email,lead.telephone,lead.origine,lead.campagne,lead.commercial,lead.statut_client] ;    
    
    const exportcsv =async (leads,choiceliste)=>{
        let csvString = [["Date Reception","Nom / Prenom","Email","Telephone","Origine","Campagne","Commercial","Statut"]] ;
        leads.forEach(item=>csvString.push(leadline(item)));
        var hiddenElement = document.createElement('a');  
        hiddenElement.href='data:text/csv;charset=utf-8,'+encodeURI(csvString.map(line => line.join(",")).join("\n"));
        hiddenElement.target='_blank';
        hiddenElement.download =`${choiceliste}${(new Date()).toISOString()}.csv`;  
        hiddenElement.click(); 
    }

    const degrerole = user?.role ==="COMMERCIAL"?1:user?.role ==="MANAGER"?2:user?.role ==="GESTION"?3:user?.role ==="ADMIN"?4:5 ;




 const gotolead =async(id)=>{gotoficheclientgestion(id);}


 const lineleads = (x)=>(<div key={x.id} className="gestionleads_tablo_line">
                            <div><input type="checkbox" name={x.id} className={classNames("gestionleads_checkbox", { 'checked': listidchange.includes(x.id) })}  onClick={clickcheckbox} /></div>
                            <div>{formatdatetime(x.date_origine)}</div>
                            <div><img height="30" width="30" src={imagesorigine(x.origine) } alt="imageorigine"  />  </div>
                            <div>{x?.campagne?.split('/')?.[0]}</div>
                            <div>{x.commercial}</div>
                            <div>{x.nom} {x.prenom}  </div>
                            <div className="cursorpointer" onClick={()=>{ gotolead(x.id)}} >{x.email}</div>
                            

                            <div>
                            {(x?.statut_client?.split('_'))?.map((y,i)=> (listestatus[y] &&<span  key={i} className={classNames('minibadge',{"minibadgeechec":x?.statut_client?.includes('echec')},{"minibadgegagne":x?.statut_client?.includes('gagne')})}> {listestatus[y]} </span> )) } </div>  
                            <div> <span className={classNames('nbrappels',{'small':x.nbappels>99},{'medium':x.nbappels<100 && x.nbappels>9},{'big': x.nbappels < 10})}>{x.nbappels}</span></div>
                        </div>) ;

    return(<>{showpopupmimi && <Mimi  leads={myliste}  setShowpopupmimi={setShowpopupmimi} />}
            {showpopupreassigner && <PopupReassigner setShowpopupreassigner={setShowpopupreassigner} listidchangecom={listidchange}  setListidchange={setListidchange}   /> }
            {showpopupsupprimer && <PopupSupprimer setShowpopupsupprimer={setShowpopupsupprimer} listidsuppression={listidchange} setListidchange={setListidchange}  /> }
            {showpopupchangestatut && <PopupChangeStatut setShowpopupchangestatut={setShowpopupchangestatut} listidchangestatut={listidchange}  setListidchange={setListidchange} /> }
                {displayprixleads ?<div className="prixleads">Prix des leads : {prixleads} €</div>  :<div className="prixleads"></div>}
                <div  className="gestionleads">
                    <div  className="gestionleads_top">
                    <div><input type="checkbox"  className={classNames("gestionleads_checkbox", { 'checked':checkall})}  onClick={clickall} /></div>
                        <div>Date de réception</div><div>Origine</div><div>Campagne</div><div>Commercial</div>
                        <div>Nom & Prénom</div><div>Email </div><div>Statut</div><div></div>
                    </div>   
                    <div  id="madivscroll"  ref={divScrollRef} className="gestionleads_tablo">
                        <div id="contentscroll"> {datasshown?.length > 0 && datasshown?.map((x)=>lineleads(x)) }</div>
                    </div>  
                </div>
                <div className="grpbtnflex">
                    <div className="exportcsv"  onClick={()=>listetocsv(myliste)} >Exporter CSV</div>
                    { degrerole >1  && <div className="reassigner"  onClick={()=>{listidchange?.length > 0 && setShowpopupreassigner(true)}} >Ré-assigner</div> }
                    { degrerole >2  && <div className="reassigner"  onClick={()=>{listidchange?.length > 0 && setShowpopupsupprimer(true)}} >Suppression</div> }
                    { degrerole >2  && <div className="reassigner"  onClick={()=>{listidchange?.length > 0 && setShowpopupchangestatut(true)}} >Modification Statut</div> }
                    { ((degrerole >2  || user.email==='jerome@cohen.ltd' )&& user.courtier==='fidelis' ) && <div className="mimibtn"  onClick={()=>{setShowpopupmimi(true)}} >Mimi</div> }
                </div>
            </>)
}

export default EcranGestionListe ; 